import React, { useState } from 'react';
import { Col, Container, Nav, Row, Tab } from 'react-bootstrap';
import FactoryRegister from './FactoryRegister';
import IndividualRegister from './IndividualRegister';

function RegisterTabs() {
  // Separate state for each registration type
  const [formData, setFormData] = useState({
    individual: {
      accountType: 'individual',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailAddress: '',
      password: '',
      confirmPassword: '',
      address: '',
      country: 'lk',
      plan: 'trial',
    },
    business: {
      accountType: 'business',
      company: '',
      phoneNumber: '',
      emailAddress: '',
      password: '',
      confirmPassword: '',
      address: '',
      country: 'lk',
    },
    factory: {
      accountType: 'factory',
      factory: '',
      phoneNumber: '',
      emailAddress: '',
      password: '',
      confirmPassword: '',
      address: '',
      country: 'lk',
    },
    group: {
      accountType: 'group',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailAddress: '',
      password: '',
      confirmPassword: '',
      address: '',
      country: 'lk',
      plan: 'trial',
    },
    buyer: {
      accountType: 'buyer',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailAddress: '',
      password: '',
      confirmPassword: '',
      address: '',
      country: 'lk',
      plan: 'trial',
    }
  });

  const [activeTab, setActiveTab] = useState('individual');
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prevState => ({
      ...prevState,
      [activeTab]: {
        ...prevState[activeTab],
        [name]: value
      }
    }));
  };

  const handleTabSelect = (key) => {
    setActiveTab(key);
    setErrors({}); // Clear errors when switching tabs
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="text-center mb-4">
            <h1 className="fw-bold text-primary">Create Your Account</h1>
            <p className="lead">Choose the account type that best fits your needs</p>
          </div>
          
          <Tab.Container 
            id="registration-tabs" 
            defaultActiveKey="individual"
            onSelect={handleTabSelect}
          >
            <Nav variant="pills" className="mb-4 justify-content-center">
              <Nav.Item>
                <Nav.Link 
                  eventKey="individual" 
                  className="mx-2 px-4 rounded-pill"
                >
                  Individual
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link 
                  eventKey="factory" 
                  className="mx-2 px-4 rounded-pill"
                >
                  Factory
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link 
                  eventKey="group" 
                  className="mx-2 px-4 rounded-pill"
                >
                  Group
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link 
                  eventKey="buyer" 
                  className="mx-2 px-4 rounded-pill"
                >
                  Buyer
                </Nav.Link>
              </Nav.Item> */}
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="individual">
                <IndividualRegister 
                  formData={formData.individual} 
                  handleChange={handleChange} 
                  errors={errors} 
                />
              </Tab.Pane>
              <Tab.Pane eventKey="factory">
                <FactoryRegister 
                  formData={formData.factory} 
                  handleChange={handleChange} 
                  errors={errors} 
                />
              </Tab.Pane>
              {/* <Tab.Pane eventKey="group">
                <GroupRegister 
                  formData={formData.group} 
                  handleChange={handleChange} 
                  errors={errors} 
                />
              </Tab.Pane>
              <Tab.Pane eventKey="buyer">
                <BuyerRegister 
                  formData={formData.buyer} 
                  handleChange={handleChange} 
                  errors={errors} 
                />
              </Tab.Pane> */}
            </Tab.Content>
          </Tab.Container>
        </Col>
      </Row>
    </Container>
  );
}

export default RegisterTabs;